// import React, { useEffect } from 'react'
import styles from './HomeSecond.module.css'
// import { useRef } from "react";
import {motion} from 'framer-motion'
import buttomImg from '../../asssists/BB.png'
import webVd from '../../asssists/web.mp4'
import AnimVd from '../../asssists/animae.mp4'
import gameVd from '../../asssists/game.mp4'
import icon from '../../asssists/icon1.svg'
import icon2 from '../../asssists/icon2.svg'
import icon3 from '../../asssists/icon3.svg'
export default function HomeSecond() {

//   let target = useRef();
//   let container = useRef();
//   let first = useRef();
//   let second = useRef();
  

//   const {scrollY} = useScroll(target,{
//     offset: ["start end", "end end"]
//   });

// useEffect(() => {
//   console.log(scrollY);
// }, [scrollY]);


  return (
    <>
    <section id='about' className={styles.HomeSecond}>
    <div className="container">
    <img src={buttomImg} className={styles.buttomImg} alt="" />
    <h2 className={styles.title}>about Us</h2>
    
    <div className="row m-auto w-100">
    <div className="col-md-12">
    <motion.div
    initial={{x:200,opacity:0,repeat:0}}
    whileInView={{x:0,opacity:1,
    transition:{duration:1,delay:0 ,ease:'easeInOut',staggerChildren:0.5 ,staggerDirection:1,repeat:0}}}
 className={styles.web}>
 <video  src={webVd} autoPlay loop muted className={styles.webVd}></video>
<motion.h2
initial={{opacity:0}}
    whileInView={{opacity:1,
      transition:{duration:1,delay:3,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
 className={styles.title2}>Web Development</motion.h2>
<motion.ul
initial={{opacity:0}}
    whileInView={{opacity:1,
      transition:{duration:1,delay:3,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}} className={styles.List}>
<li>MEET DEADLINES</li>
<li>RESP0NSIVE DESIGN</li>
<li>QUALITY CONTROL</li>
<li>UI/UX</li>
<li>24/7 SUPPORT</li>
<li>MODERN DESIGN</li>
<li>FREE DEPLOYMENT</li>

</motion.ul>
<motion.img 
initial={{opacity:0}}
  whileInView={{opacity:1,
  transition:{duration:1,delay:3,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
src={icon} className={styles.icon} alt="" />
</motion.div>

    
    </div>
    </div>
    <div className="row m-auto w-100">
    <div className="col-md-12">
    
    <motion.div
    initial={{x:-200,opacity:0}}
    whileInView={{x:0,opacity:1,
    transition:{duration:1,delay:0 ,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
    className={styles.anime_game}>
    <video  src={AnimVd} autoPlay loop muted className={styles.animVd}></video>
    <motion.h2
    initial={{opacity:0}}
    whileInView={{opacity:1,
      transition:{duration:1,delay:5,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
      className={styles.title2}>ANIMATiON & GAMES</motion.h2>
    <motion.ul
    initial={{opacity:0}}
    whileInView={{opacity:1,
    transition:{duration:1,delay:5,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
     className={styles.List}>
    <li>MEET DEADLINES</li>
    <li>CUSTOMIZE GAMES</li>
    <li>CUSTOMIZE ANIMETION VIDEOS</li>
    <li>CUSTOMIZE CHARACTER CHOISE</li>
    <li>24/7 SUPPORT</li>
    
    </motion.ul>
    <motion.img 
initial={{opacity:0}}
  whileInView={{opacity:1,
  transition:{duration:1,delay:5,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
src={icon2} className={styles.icon} alt="" />
    </motion.div>
    </div>
    </div>

    <div className="row m-auto w-100 ">
    <div className="col-md-12">
    <motion.div
    initial={{x:200,opacity:0,repeat:0}}
    whileInView={{x:0,opacity:1,
    transition:{duration:1,delay:0 ,ease:'easeInOut',staggerChildren:0.5 ,staggerDirection:1,repeat:0}}}
 className={styles.gamesec}>
 <video src={gameVd} autoPlay loop muted className={`mb-5 ${styles.animVd}`}></video>
<motion.h2
initial={{opacity:0}}
    whileInView={{opacity:1,
      transition:{duration:1,delay:3,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
      className={styles.title2}>Game Development</motion.h2>
<motion.ul
initial={{opacity:0}}
    whileInView={{opacity:1,
      transition:{duration:1,delay:3,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}} className={styles.List}>
<li>MEET DEADLINES</li>
<li>CUSTOMIZE GAMES</li>
<li>QUALITY CONTROL</li>
<li>ANY KIND OF GAME</li>
<li>24/7 SUPPORT</li>
<li>MODERN GAMES</li>

</motion.ul>
<motion.img 
initial={{opacity:0}}
  whileInView={{opacity:1,
  transition:{duration:1,delay:3,ease:'easeIn',staggerChildren:0.5 ,staggerDirection:1,repeatType:'once'}}}
src={icon3} className={styles.icon} alt="" />
</motion.div>

    
    </div>
    </div>

    </div>
    </section>
    </>
  )
}
